import { render } from "./PersonInformation.vue?vue&type=template&id=76d7d1ae"
import script from "./PersonInformation.vue?vue&type=script&lang=js"
export * from "./PersonInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__